import { form } from '../formState'

import { useTexts } from '../../hooks/useTexts'

export function ShowETARange() {
  const texts = useTexts()

  return (
    <form.Checkbox
      name="showEtaRange"
      label={texts.showEtaRange}
      testId="showEtaRange"
      validateOn="focus blur"
      helperText={texts.showEtaRangeHelperText}
    />
  )
}
